import React, { useState, useRef } from "react";

import { ReactComponent as UserIcon } from "./../assets/user_icon.svg";
import { HiOutlineMenu } from "react-icons/hi";
import { SlArrowRight, SlArrowLeft } from "react-icons/sl";
import DateItem from "../components/Date";

const AppointmentSecondaryScreen = () => {
  const [activeDate, setActiveDate] = useState(0);

  const dateData = [
    {
      id: 0,
      day: "Today",
      date: "07",
      month: "JUN",
    },
    {
      id: 1,
      day: "SAT",
      date: "08",
      month: "JUN",
    },
    {
      id: 2,
      day: "SUN",
      date: "09",
      month: "JUN",
    },
    {
      id: 3,
      day: "MON",
      date: "10",
      month: "JUN",
    },
    {
      id: 4,
      day: "TUE",
      date: "11",
      month: "JUN",
    },
    {
      id: 5,
      day: "WED",
      date: "12",
      month: "JUN",
    },
    {
      id: 6,
      day: "Today",
      date: "07",
      month: "JUN",
    },
    {
      id: 7,
      day: "SAT",
      date: "08",
      month: "JUN",
    },
    {
      id: 8,
      day: "SUN",
      date: "09",
      month: "JUN",
    },
    {
      id: 9,
      day: "MON",
      date: "10",
      month: "JUN",
    },
    {
      id: 10,
      day: "TUE",
      date: "11",
      month: "JUN",
    },
    {
      id: 11,
      day: "WED",
      date: "12",
      month: "JUN",
    },
    {
      id: 12,
      day: "Today",
      date: "07",
      month: "JUN",
    },
    {
      id: 13,
      day: "SAT",
      date: "08",
      month: "JUN",
    },
    {
      id: 14,
      day: "SUN",
      date: "09",
      month: "JUN",
    },
    {
      id: 15,
      day: "MON",
      date: "10",
      month: "JUN",
    },
    {
      id: 16,
      day: "TUE",
      date: "11",
      month: "JUN",
    },
    {
      id: 17,
      day: "WED",
      date: "12",
      month: "JUN",
    },
  ];

  const dateSlotScrollRef = useRef();

  const handleLeftScroll = () => {
    const scrollElement = dateSlotScrollRef.current;

    const visibleWidth = scrollElement.clientWidth;

    scrollElement.scrollLeft -= visibleWidth - 100;
  };

  const handleRightScroll = () => {
    const scrollElement = dateSlotScrollRef.current;

    // const sliderPosition = scrollElement.scrollLeft;

    // const maxScroll = scrollElement.scrollWidth;

    const visibleWidth = scrollElement.clientWidth;

    // const offset = (maxScroll - visibleWidth) - 100;

    // if (!(sliderPosition >= offset)) {
    scrollElement.scrollLeft += visibleWidth - 100;
    // }
  };

  return (
    <div
      className="container-fluid p-0 position-relative"
      style={{
        overflow: "hidden",
        backgroundColor: "#fae5ff",
      }}
    >
      <div
        className=""
        style={{
          position: "absolute",
          left: "50%",
          top: "0",
          height: "100vh",
          width: "165vw",
          borderRadius: "50%",
          transform: "translateX(-50%) translateY(-65%)",
          backgroundColor: "rgb(203, 108, 230)",
          zIndex: "10",
        }}
      ></div>

      <div
        className=""
        style={{
          position: "absolute",
          left: "50%",
          top: "0",
          height: "100vh",
          width: "175vw",
          borderRadius: "50%",
          transform: "translateX(-55%) translateY(-60%)",
          backgroundColor: "rgb(220, 143, 241)",
          zIndex: "0",
        }}
      ></div>

      <div
        className="row w-100 mx-auto flex-column align-items-center position-relative"
        style={{
          minHeight: "100vh",
          zIndex: "100",
          padding: "2px 15px 10px 15px",
          // backgroundColor: '#fae5ff'
        }}
      >
        <div
          className="col-12"
          style={{
            padding: "10px 0",
          }}
        >
          <div className="row w-100 mx-auto align-items-center justify-content-between">
            <div className="col-auto p-0">
              <div
                className="d-flex"
                style={{
                  gap: "16px",
                }}
              >
                <HiOutlineMenu
                  style={{
                    color: "#fae5ff",
                    height: "29px",
                    width: "29px",
                  }}
                />

                <div
                  className=""
                  style={{
                    color: "#fae5ff",
                    fontSize: "28px",
                    fontWeight: "600",
                    lineHeight: "1",
                  }}
                >
                  SmileApp
                </div>
              </div>
            </div>
            <div className="col-auto p-0">
              <div
                className=""
                style={{
                  width: "40px",
                }}
              >
                <UserIcon
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 p-0">
          <div className="row w-100 mx-auto flex-column align-items-center justify-content-between">
            <div className="col-12 p-0">
              <div
                className=""
                style={{
                  backgroundColor: "rgb(255, 255, 255)",
                  padding: "13px 5px 30px 5px",
                  borderRadius: "16px",
                }}
              >
                <div
                  className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                  style={{
                    marginTop: "8px",
                    gap: "22px",
                    // overflowY: 'scroll',
                    // scrollBehavior: 'smooth'
                  }}
                >
                  <div className="col-12 p-0">
                    <div
                      className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                      style={{
                        gap: "18px",
                      }}
                    >
                      <div className="col-auto p-0">
                        <div
                          className="text-center"
                          style={{
                            fontSize: "11px",
                            color: "rgb(220, 143, 241)",
                          }}
                        >
                          Select Your Slot
                        </div>
                      </div>
                      <div className="col-12 p-0 px-sm-4">
                        <div
                          className="row w-100 mx-auto align-items-center justify-content-center flex-nowrap"
                          style={
                            {
                              // gap: '10px'
                            }
                          }
                        >
                          <div className="col-auto p-0">
                            <div className="d-flex align-items-center justify-content-center">
                              <SlArrowLeft
                                style={{
                                  color: "rgb(203, 108, 230)",
                                  height: "16px",
                                  width: "16px",
                                }}
                                onClick={() => handleLeftScroll()}
                              />
                            </div>
                          </div>
                          <div
                            className="col p-0 date-slot-scroll"
                            ref={dateSlotScrollRef}
                            style={{
                              overflow: "scroll",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "none",
                            }}
                          >
                            <div
                              className="row w-100 mx-auto align-items-center justify-content-start flex-nowrap"
                              style={{
                                gap: "5px",
                                // overflow: 'scroll',
                              }}
                            >
                              {dateData.map((date, index) => {
                                return (
                                  <DateItem
                                    key={date.id}
                                    active={activeDate === index}
                                    setActive={setActiveDate}
                                    data={date}
                                  />
                                );
                              })}
                            </div>
                          </div>
                          <div className="col-auto p-0">
                            <div className="d-flex align-items-center justify-content-center">
                              <SlArrowRight
                                style={{
                                  color: "rgb(203, 108, 230)",
                                  height: "16px",
                                  width: "16px",
                                }}
                                onClick={() => handleRightScroll()}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 p-0">
                    <div
                      className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                      style={{
                        gap: "10px",
                      }}
                    >
                      <div className="col-auto p-0">
                        <div
                          className="text-center"
                          style={{
                            fontSize: "11px",
                            color: "rgb(220, 143, 241)",
                          }}
                        >
                          Morning
                        </div>
                      </div>
                      <div className="col-12 p-0 px-sm-4">
                        <div
                          className="w-100 mx-auto"
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr",
                            gridTemplateRows:
                              "minmax(min-content, max-content)",
                            rowGap: "14px",
                            columnGap: "10px",
                            padding: "0 5px",
                          }}
                        >
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                09:30 AM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                09:30 AM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                10:00 AM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                10:30 AM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                11:00 AM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                11:30 AM
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 p-0">
                    <div
                      className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                      style={{
                        gap: "10px",
                      }}
                    >
                      <div className="col-auto p-0">
                        <div
                          className="text-center"
                          style={{
                            fontSize: "11px",
                            color: "rgb(220, 143, 241)",
                          }}
                        >
                          Day
                        </div>
                      </div>
                      <div className="col-12 p-0 px-sm-4">
                        <div
                          className="w-100 mx-auto"
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr",
                            gridTemplateRows:
                              "minmax(min-content, max-content)",
                            rowGap: "14px",
                            columnGap: "10px",
                            padding: "0 5px",
                          }}
                        >
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                01:00 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                01:30 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                02:00 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                02:30 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                03:00 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                03:30 PM
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 p-0">
                    <div
                      className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                      style={{
                        gap: "10px",
                      }}
                    >
                      <div className="col-auto p-0">
                        <div
                          className="text-center"
                          style={{
                            fontSize: "11px",
                            color: "rgb(220, 143, 241)",
                          }}
                        >
                          Evening
                        </div>
                      </div>
                      <div className="col-12 p-0 px-sm-4">
                        <div
                          className="w-100 mx-auto"
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr",
                            gridTemplateRows:
                              "minmax(min-content, max-content)",
                            rowGap: "14px",
                            columnGap: "10px",
                            padding: "0 5px",
                          }}
                        >
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                05:00 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                05:30 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                06:00 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                06:30 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                07:00 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                07:30 PM
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 p-0">
                    <div
                      className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                      style={{
                        gap: "10px",
                      }}
                    >
                      <div className="col-auto p-0">
                        <div
                          className="text-center"
                          style={{
                            fontSize: "11px",
                            color: "rgb(220, 143, 241)",
                          }}
                        >
                          Night
                        </div>
                      </div>
                      <div className="col-12 p-0 px-sm-4">
                        <div
                          className="w-100 mx-auto"
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr",
                            gridTemplateRows:
                              "minmax(min-content, max-content)",
                            rowGap: "14px",
                            columnGap: "10px",
                            padding: "0 5px",
                          }}
                        >
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                09:00 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                09:30 PM
                              </div>
                            </button>
                          </div>
                          <div className="p-0">
                            <button
                              className="btn w-100 service-btn"
                              style={{
                                padding: "9px 8px",
                                border: "1px solid rgb(250, 229, 255)",
                                borderRadius: "20px",
                                lineHeight: "1",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "11px",
                                  color: "rgb(153, 0, 204)",
                                  fontWeight: "400",
                                }}
                              >
                                10:00 PM
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="row w-100 mx-auto align-items-center justify-content-center"
                  style={{
                    marginTop: "30px",
                  }}
                >
                  <div className="col-auto p-0">
                    <button
                      className="btn text-center"
                      type=""
                      style={{
                        fontSize: "10.5px",
                        fontWeight: "normal",
                        backgroundColor: "rgb(203, 108, 230)",
                        color: "rgb(250, 229, 255)",
                        // textDecoration: 'underline',
                        borderRadius: "20px",
                        padding: "9px 26px",
                        lineHeight: "1",
                      }}
                    >
                      Book Appointment Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentSecondaryScreen;
